import type { PcmpHoldStage, PcmpRejectedAtStage } from '../types/pcmpProposal.types';

/** API PCMP_HOLD_STAGE_LABELS; only for naming the stage before a hold. */
export const PCMP_HOLD_STAGE_LABELS = {
  MARKETING: 'Marketing (L1/L2)',
  MIS: 'MIS',
  ACCOUNTS: 'Accounts Disbursement',
  MKT_DISBURSE: 'Marketing Disbursement',
} as const satisfies Record<PcmpHoldStage, string>;

export const PCMP_HOLD_ACTION_COPY = {
  HOLD: {
    label: 'Hold',
    title: 'Put on Hold',
    submit: 'Put on hold',
    pending: 'Holding...',
    required: 'A reason is required to put a proposal on hold.',
  },
  RELEASE: {
    label: 'Release',
    title: 'Release from Hold',
    submit: 'Release',
    pending: 'Releasing...',
    required: 'A comment is required to release a proposal from hold.',
  },
} as const;

/** API PCMP_REJECTED_AT_STAGE_LABELS; only for naming the stage before an admin reject. */
export const PCMP_REJECTED_AT_STAGE_LABELS = {
  MARKETING: 'Marketing (L1/L2)',
  MIS: 'MIS Verification',
  PRE_BATCH: 'MIS (Pre-Batch)',
  ROUTE_BATCH: 'MIS Routing Batch',
  ACCOUNTS: 'Accounts Disbursement',
  ACC_CORRECTION: 'Accounts Correction',
  MKT_DISBURSE: 'Marketing Disbursement',
} as const satisfies Record<PcmpRejectedAtStage, string>;
